export default __webpack_public_path__ + "static/media/testimoni5.77b90630.webp";